import { render, staticRenderFns } from "./BagType.vue?vue&type=template&id=cd60622e&scoped=true&"
import script from "./BagType.vue?vue&type=script&lang=js&"
export * from "./BagType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd60622e",
  null
  
)

export default component.exports